import { APP_LS_NAMESPACE_ID } from 'src/constants';
import {
  APPLICANT, SMARTMATCH_TYPE_ADMIN, STATUS_SUBMITTED,
  STATUS_PRE_QUALIFIED,
  STATUS_DOCUMENTS_SIGNED,
  STATUS_BOOKING_COMPLETE,
  STATUS_FUNDING,
  STATUS_APPLICATION_STARTED,
  STATUS_UNDER_REVIEW,
  STATUS_WITHDRAW,
  STATUS_DECLINED,
  STATUS_CLEAR_TO_CLOSE_COMPLETED,
  STATUS_APPROVED,
  SMARTMATCH_TYPE_LOAN_OFFICER,
  STATUS_CLOSED_FOR_INCOMPLETENESS,
  SMARTMATCH_TYPE_CREDIT_MANAGER,
  STATUS_DENIAL_UNDER_REVIEW,
  STATUS_CREDIT_APPROVAL,
  STATUS_RECOMMENDED_DECLINE,
  STATUS_RECOMMENDED_APPROVE,
  STATUS_REQUEST_APPROVAL,
  STATUS_APPRAISAL_ORDER,
  STATUS_APPRAISAL_COMPLETE,
  STATUS_SOFT_DECLINED,
  STATUS_UNTOUCHED,
  STATUS_CENTRAL_GROUP_REVIEW,
  STATUS_APPROVED_NOT_ACCEPTED,
  SMARTMATCH_TYPE_RATE_APPROVER,
  STATUS_DOCS_IN_EPRINT,
  STATUS_DOCS_IN_DOCUSIGN
} from 'src/services/constants';
import {
  HOME_EQUITY,
  PERSONALLOANS,
  SECURED,
  UNSECURED,
} from 'src/features/LoansHome/Products/constants';
import { AUDITOR, USER_ONBOARD_CDP_OFFICER, USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER, USER_ONBOARD_DIGITAL_RM } from 'src/services/constants/accounts';
import { 
  ADVISOR_LENDING_LIMIT_EXCEEDS, 
  ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
  ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT
 } from 'src/features/RBAC/Rules/permissionData';


const applicantStages = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [SECURED, UNSECURED],
  stages: [
    {
      name: STATUS_APPLICATION_STARTED,
      display_name: STATUS_APPLICATION_STARTED,
      order_id: 1,
      children: [
        {
          stages: [
            {
              name: STATUS_SUBMITTED,
              display_name: STATUS_SUBMITTED,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_SUBMITTED,
      display_name: STATUS_SUBMITTED,
      order_id: 2,
      children: [
        {
          stages: [
            {
              name: STATUS_UNDER_REVIEW,
              display_name: STATUS_UNDER_REVIEW,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_UNDER_REVIEW,
      display_name: STATUS_UNDER_REVIEW,
      order_id: 3,
      children: [
        {
          stages: [
            {
              name: STATUS_PRE_QUALIFIED,
              display_name: STATUS_PRE_QUALIFIED,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_PRE_QUALIFIED,
      display_name: STATUS_PRE_QUALIFIED,
      order_id: 4,
      children: [
        {
          stages: [
            {
              name: STATUS_APPROVED,
              display_name: STATUS_APPROVED,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_APPROVED,
      display_name: STATUS_APPROVED,
      order_id: 5,
      children: [
        {
          stages: [
            {
              name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
              display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
      display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
      order_id: 6,
      children: [
        {
          stages: [
            {
              name: STATUS_BOOKING_COMPLETE,
              display_name: STATUS_BOOKING_COMPLETE,
            }
          ]
        },
      ]
    }
  ],
  roles: [APPLICANT],
} as any

const applicantStagesHeloc = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [HOME_EQUITY],
  stages: [
    {
      name: STATUS_APPLICATION_STARTED,
      display_name: STATUS_APPLICATION_STARTED,
      order_id: 1,
      children: [
        {
          stages: [
            {
              name: STATUS_SUBMITTED,
              display_name: STATUS_SUBMITTED,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_SUBMITTED,
      display_name: STATUS_SUBMITTED,
      order_id: 2,
      children: [
        {
          stages: [
            {
              name: STATUS_UNDER_REVIEW,
              display_name: STATUS_UNDER_REVIEW,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_UNDER_REVIEW,
      display_name: STATUS_UNDER_REVIEW,
      order_id: 3,
      children: [
        {
          stages: [
            {
              name: STATUS_PRE_QUALIFIED,
              display_name: STATUS_PRE_QUALIFIED,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_PRE_QUALIFIED,
      display_name: STATUS_PRE_QUALIFIED,
      order_id: 4,
      children: [
        {
          stages: [
            {
              name: STATUS_APPROVED,
              display_name: STATUS_APPROVED,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_APPROVED,
      display_name: STATUS_APPROVED,
      order_id: 5,
      children: [
        {
          stages: [
            {
              name: STATUS_DOCUMENTS_SIGNED,
              display_name: STATUS_DOCUMENTS_SIGNED,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_DOCUMENTS_SIGNED,
      display_name: STATUS_DOCUMENTS_SIGNED,
      order_id: 6,
      children: [
        {
          stages: [
            {
              name: STATUS_FUNDING,
              display_name: STATUS_FUNDING,
            }
          ]
        },
      ]
    },
    {
      name: STATUS_FUNDING,
      display_name: STATUS_FUNDING,
      order_id: 7,
      children: [
        {
          stages: [
            {
              name: STATUS_BOOKING_COMPLETE,
              display_name: STATUS_BOOKING_COMPLETE,
            }
          ]
        },
      ]
    }
  ],
  roles: [APPLICANT],
} as any


const stageStarted = {
  name: STATUS_APPLICATION_STARTED,
  display_name: STATUS_APPLICATION_STARTED,
  order_id: 1,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
          display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        }
      ]
    },
  ]
}

const stageSubmitted = {
  name: STATUS_SUBMITTED,
  display_name: STATUS_SUBMITTED,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
          order: 3
        },
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
          display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        }
      ]
    },
  ]
}

const stageUnderReview = {
  name: STATUS_UNDER_REVIEW,
  display_name: STATUS_RECOMMENDED_DECLINE,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        }
      ]
    },
    {
      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_CREDIT_APPROVAL,
          display_name: STATUS_CREDIT_APPROVAL,
          order: 3
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        }
      ]
    }
  ]
}

const stageDenialUnderReview = {
  name: STATUS_DENIAL_UNDER_REVIEW,
  display_name: STATUS_DENIAL_UNDER_REVIEW,
  children: [
    {
      stages: [
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
        },
      ]
    }
  ]
}

const stageDenialUnderReviewHeloc = {
  name: STATUS_DENIAL_UNDER_REVIEW,
  display_name: STATUS_DENIAL_UNDER_REVIEW,
  children: [
    {
      stages: [
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        }
      ]
    }
  ]
}

const stagePreQualified = {
  name: STATUS_PRE_QUALIFIED,
  display_name: STATUS_RECOMMENDED_APPROVE,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,

      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
  ]
}


const stagePreQualifiedAdmin = {
  name: STATUS_PRE_QUALIFIED,
  display_name: STATUS_RECOMMENDED_APPROVE,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {

      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
  ]
}
const stageApproval = {
  name: STATUS_REQUEST_APPROVAL,
  display_name: STATUS_REQUEST_APPROVAL,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
  ]
}

const stageApprovalAdmin = {
  name: STATUS_REQUEST_APPROVAL,
  display_name: STATUS_REQUEST_APPROVAL,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        }
      ]
    },
    {
      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
  ]
}

const stageCreditApproval = {
  name: STATUS_CREDIT_APPROVAL,
  display_name: STATUS_CREDIT_APPROVAL,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]

    }
  ]
}


const stageCreditApprovalAdmin = {
  name: STATUS_CREDIT_APPROVAL,
  display_name: STATUS_CREDIT_APPROVAL,
  order_id: 2,
  children: [

    {
      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]

    }
  ]
}



const stageApproved = {
  name: STATUS_APPROVED,
  display_name: STATUS_APPROVED,
  order_id: 2,
  children: [
    {
      stages: [

        {
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
  ]
}

const stageWithdrawn = {
  name: STATUS_WITHDRAW,
  display_name: STATUS_WITHDRAW,
  order_id: 2,
  children: []
}

const stageClosedForIncomplete = {
  name: STATUS_CLOSED_FOR_INCOMPLETENESS,
  display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
  order_id: 2,
  children: []
}

const stageUntouched = {
  name: STATUS_UNTOUCHED,
  display_name: STATUS_UNTOUCHED,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
        },
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
          display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        }
      ]
    }
  ]
}

const stageSoftDeclined = {
  name: STATUS_SOFT_DECLINED,
  display_name: STATUS_SOFT_DECLINED,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
        },
        {
          name: STATUS_CREDIT_APPROVAL,
          display_name: STATUS_CREDIT_APPROVAL
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        }
      ]
    }
  ]
}


const stageCenterGroupReview = {
  name: STATUS_CENTRAL_GROUP_REVIEW,
  display_name: STATUS_CENTRAL_GROUP_REVIEW,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
          display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        }
      ]
    },
  ]
}

const stageStartedHeloc = {
  name: STATUS_APPLICATION_STARTED,
  display_name: STATUS_APPLICATION_STARTED,
  order_id: 1,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
          display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        }
      ]
    },
  ]
}

const stageClearToCloseForSecuredUnSecuredRM = {
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  children: [
    {
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW
        }
      ]
    },
  ]
}



const stageClearToCloseForSecuredUnSecured = {
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  children: [
    {
      stages: [
        {
          name: STATUS_BOOKING_COMPLETE,
          display_name: STATUS_BOOKING_COMPLETE
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW
        },
        {
          name: STATUS_DOCS_IN_EPRINT,
          display_name: STATUS_DOCS_IN_EPRINT
        },
        {
          name: STATUS_DOCS_IN_DOCUSIGN,
          display_name: STATUS_DOCS_IN_DOCUSIGN
        }
      ]
    },
  ]
}

const stageClearToCloseForCDP = {
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  children: [
    {
      stages: [
        {
          name: STATUS_DOCS_IN_EPRINT,
          display_name: STATUS_DOCS_IN_EPRINT
        },
        {
          name: STATUS_DOCS_IN_DOCUSIGN,
          display_name: STATUS_DOCS_IN_DOCUSIGN
        }
      ]
    },
  ]
}

const stageDocsEPrint = {
  name: STATUS_DOCS_IN_EPRINT,
  display_name: STATUS_DOCS_IN_EPRINT,
  children: [
    {
      stages: [
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        }
      ]
    },
  ]
}

const stageDocsInDocuSign = {
  name: STATUS_DOCS_IN_DOCUSIGN,
  display_name: STATUS_DOCS_IN_DOCUSIGN,
  children: [
    {
      stages: [
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        }
      ]
    },
  ]
}


const stageUnderReviewHeloc = {
  name: STATUS_UNDER_REVIEW,
  display_name: STATUS_RECOMMENDED_DECLINE,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        }
      ]
    },
    {
      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
          display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        }
      ]
    }
  ]
}

const stagePreQualifiedHeloc = {
  name: STATUS_PRE_QUALIFIED,
  display_name: STATUS_RECOMMENDED_APPROVE,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
      stages: [

        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    }
  ]
}



const stagePreQualifiedHelocAdmin = {
  name: STATUS_PRE_QUALIFIED,
  display_name: STATUS_RECOMMENDED_APPROVE,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    }
  ]
}


const stageApprovalHeloc = {
  name: STATUS_REQUEST_APPROVAL,
  display_name: STATUS_REQUEST_APPROVAL,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
          order: 6
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {

      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
          order: 6
        },
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,

      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
          order: 6
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
  ]
}



const stageApprovalHelocAdmin = {
  name: STATUS_REQUEST_APPROVAL,
  display_name: STATUS_REQUEST_APPROVAL,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
          order: 6
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
          order: 6
        },
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    }
  ]
}

const stageCreditApprovalHeloc = {
  name: STATUS_CREDIT_APPROVAL,
  display_name: STATUS_CREDIT_APPROVAL,
  order_id: 3,
  children: [
    {
      permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,

      stages: [


        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    }
  ]
}



const stageCreditApprovalHelocAdmin = {
  name: STATUS_CREDIT_APPROVAL,
  display_name: STATUS_CREDIT_APPROVAL,
  order_id: 3,
  children: [

    {
      stages: [
        {
          name: STATUS_APPROVED,
          display_name: STATUS_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    }
  ]
}



const stageApprovedHeloc = {
  name: STATUS_APPROVED,
  display_name: STATUS_APPROVED,
  order_id: 2,
  children: [

    {
      stages: [

        {
          name: STATUS_APPRAISAL_ORDER,
          display_name: STATUS_APPRAISAL_ORDER,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        }
      ]
    },
  ]
}
const stageAppraisalOrder = {
  name: STATUS_APPRAISAL_ORDER,
  display_name: STATUS_APPRAISAL_ORDER,
  order_id: 2,
  children: [
    {
      stages: [

        {
          name: STATUS_APPRAISAL_COMPLETE,
          display_name: STATUS_APPRAISAL_COMPLETE,
          order: 5
        }
      ]
    },
  ]
}

const stageAppraisalComplete = {
  name: STATUS_APPRAISAL_COMPLETE,
  display_name: STATUS_APPRAISAL_COMPLETE,
  order_id: 2,
  children: [
    {
      stages: [

        {
          name: STATUS_DOCUMENTS_SIGNED,
          display_name: STATUS_DOCUMENTS_SIGNED,
          order: 5
        }
      ]
    },
  ]
}

const stageDocSigning = {
  name: STATUS_DOCUMENTS_SIGNED,
  display_name: STATUS_DOCUMENTS_SIGNED,
  order_id: 2,
  children: [
    {
      stages: [

        {
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          order: 5
        }
      ]
    },
  ]
}

const stageClearToCloseLo = {
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  order_id: 2,
  children: [
    {
      stages: [

        {
          name: STATUS_FUNDING,
          display_name: STATUS_FUNDING,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        }
      ]
    },
  ]
}


const stageClearToClose = {
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_FUNDING,
          display_name: STATUS_FUNDING,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_DOCS_IN_EPRINT,
          display_name: STATUS_DOCS_IN_EPRINT
        },
        {
          name: STATUS_DOCS_IN_DOCUSIGN,
          display_name: STATUS_DOCS_IN_DOCUSIGN
        }
      ]
    },
  ]
}

const stageFunding = {
  name: STATUS_FUNDING,
  display_name: STATUS_FUNDING,
  order_id: 2,
  children: [
    {
      stages: [

        {
          name: STATUS_BOOKING_COMPLETE,
          display_name: STATUS_BOOKING_COMPLETE,
          order: 5
        }
      ]
    },
  ]
}

const stageWithdrawnHeloc = {
  name: STATUS_WITHDRAW,
  display_name: STATUS_WITHDRAW,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED
        }
      ]
    },
  ]
}

const stageDeclinedHeloc = {
  name: STATUS_DECLINED,
  display_name: STATUS_DECLINED,
  children: [{
    stages: [
      {
        name: STATUS_SUBMITTED,
        display_name: STATUS_SUBMITTED
      }
    ]
  }]
}


const stageDocsEPrintLoanCloseEdit = {
  name: STATUS_DOCS_IN_EPRINT,
  display_name: STATUS_DOCS_IN_EPRINT,
  children: [
    {
      stages: [
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_BOOKING_COMPLETE,
          display_name: STATUS_BOOKING_COMPLETE
        }
      ]
    },
  ]
}

const stageDocsESignLoanCloseEdit = {
  name: STATUS_DOCS_IN_DOCUSIGN,
  display_name: STATUS_DOCS_IN_DOCUSIGN,
  children: [
    {
      stages: [
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_BOOKING_COMPLETE,
          display_name: STATUS_BOOKING_COMPLETE
        }
      ]
    },
  ]
}

const stageApprovedNotAcceptedEdit = {
  name: STATUS_APPROVED_NOT_ACCEPTED,
  display_name: STATUS_APPROVED_NOT_ACCEPTED,
  children: [
    {
      stages: [
        {
          name: STATUS_BOOKING_COMPLETE,
          display_name: STATUS_BOOKING_COMPLETE
        }
      ]
    },
  ]
}



const loStageHelocConfigs = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [HOME_EQUITY],
  roles: [SMARTMATCH_TYPE_LOAN_OFFICER],
  stages: [
    stageStartedHeloc,
    stageSubmitted,
    stageUnderReviewHeloc,
    stagePreQualifiedHeloc,
    stageApprovalHeloc,
    stageApprovedHeloc,
    stageAppraisalOrder,
    stageAppraisalComplete,
    stageDocSigning,
    stageClearToCloseLo,
    stageFunding,
    {
      name: STATUS_BOOKING_COMPLETE,
      display_name: STATUS_BOOKING_COMPLETE
    },
    stageWithdrawnHeloc,
    stageDeclinedHeloc
  ]
} as any;


const cdpStageHelocConfigs = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [HOME_EQUITY],
  roles: [USER_ONBOARD_CDP_OFFICER],
  stages: [
    stageStartedHeloc,
    stageSubmitted,
    stageUnderReviewHeloc,
    stagePreQualifiedHeloc,
    stageApprovalHeloc,
    stageApprovedHeloc,
    stageAppraisalOrder,
    stageAppraisalComplete,
    stageDocSigning,
    stageClearToCloseForCDP,
    stageFunding,
    {
      name: STATUS_BOOKING_COMPLETE,
      display_name: STATUS_BOOKING_COMPLETE,

    },
    stageWithdrawnHeloc,
    stageDeclinedHeloc
  ]
} as any;

const cmStagesHeloc = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [HOME_EQUITY],
  roles: [
    SMARTMATCH_TYPE_CREDIT_MANAGER
  ],
  stages: [
    stageStartedHeloc,
    stageSubmitted,
    stageUnderReviewHeloc,
    stagePreQualifiedHeloc,
    stageApprovalHeloc,
    stageCreditApprovalHeloc,
    stageApprovedHeloc,
    stageAppraisalOrder,
    stageAppraisalComplete,
    stageDocSigning,
    stageClearToClose,
    stageDocsEPrint,
    stageDocsInDocuSign,
    stageDenialUnderReviewHeloc,
    stageFunding,
    {
      name: STATUS_BOOKING_COMPLETE,
      display_name: STATUS_BOOKING_COMPLETE,

    },
    stageWithdrawnHeloc,
    stageDeclinedHeloc
  ]
} as any;

const adminStagesHeloc = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [HOME_EQUITY],
  roles: [
    SMARTMATCH_TYPE_ADMIN,
  ],
  stages: [
    stageStartedHeloc,
    stageSubmitted,
    stageUnderReviewHeloc,
    stagePreQualifiedHelocAdmin,
    stageApprovalHelocAdmin,
    stageCreditApprovalHelocAdmin,
    stageApprovedHeloc,
    stageAppraisalOrder,
    stageAppraisalComplete,
    stageDocSigning,
    stageClearToClose,
    stageDocsEPrintLoanCloseEdit,
    stageDocsESignLoanCloseEdit,
    stageApprovedNotAcceptedEdit,
    stageDenialUnderReviewHeloc,
    stageFunding,
    {
      name: STATUS_BOOKING_COMPLETE,
      display_name: STATUS_BOOKING_COMPLETE,

    },
    stageWithdrawnHeloc,
    stageDeclinedHeloc
  ]
} as any;




const drmStageConfigs = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [SECURED, UNSECURED],
  stages: [
    stageStarted,
    stageSubmitted,
    stageCenterGroupReview,
    stageUnderReview,
    stagePreQualified,
    stageApproval,
    stageApproved,
    stageWithdrawn,
    stageClosedForIncomplete,
    stageClearToCloseForSecuredUnSecuredRM,
    stageDocsEPrint,
    stageDocsInDocuSign,
    stageUntouched,
    stageSoftDeclined
  ],
  roles: [USER_ONBOARD_DIGITAL_RM],
} as any


const drmStageHelocConfigs = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [HOME_EQUITY],
  roles: [USER_ONBOARD_DIGITAL_RM],
  stages: [
    stageStartedHeloc,
    stageSubmitted,
    stageUnderReviewHeloc,
    stagePreQualifiedHeloc,
    stageApprovalHeloc,
    stageApprovedHeloc,
    stageAppraisalOrder,
    stageAppraisalComplete,
    stageDocSigning,
    stageClearToCloseLo,
    stageCenterGroupReview,
    stageWithdrawnHeloc,
    stageDeclinedHeloc
  ]
} as any;





const rateApproverStageConfigs = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [SECURED, UNSECURED],
  stages: [
    stageStarted,
    stageSubmitted,
    stageUnderReview,
    stagePreQualifiedAdmin,
    stageApprovalAdmin,
    stageCreditApprovalAdmin,
    stageApproved,
    stageWithdrawn,
    stageClosedForIncomplete,
    stageClearToCloseForSecuredUnSecuredRM,
    stageUntouched,
    stageSoftDeclined
  ],
  roles: [SMARTMATCH_TYPE_RATE_APPROVER],
} as any


const rateApproverStageHelocConfigs = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [HOME_EQUITY],
  roles: [SMARTMATCH_TYPE_RATE_APPROVER],
  stages: [
    stageStartedHeloc,
    stageSubmitted,
    stageUnderReviewHeloc,
    stagePreQualifiedHelocAdmin,
    stageCreditApprovalHelocAdmin,
    stageApprovalHelocAdmin,
    stageApprovedHeloc,
    stageAppraisalOrder,
    stageAppraisalComplete,
    stageDocSigning,
    stageClearToCloseLo,
    stageFunding,
    {
      name: STATUS_BOOKING_COMPLETE,
      display_name: STATUS_BOOKING_COMPLETE,

    },
    stageWithdrawnHeloc,
    stageDeclinedHeloc
  ]
} as any;

const loStageConfigs = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [SECURED, UNSECURED],
  stages: [
    stageStarted,
    stageSubmitted,
    stageUnderReview,
    stagePreQualified,
    stageApproval,
    stageApproved,
    stageWithdrawn,
    stageClosedForIncomplete,
    stageClearToCloseForSecuredUnSecuredRM,
    stageDocsEPrint,
    stageDocsInDocuSign,
    stageUntouched,
    stageSoftDeclined
  ],
  roles: [SMARTMATCH_TYPE_LOAN_OFFICER],
} as any

const cdpStageConfigs = {
  id: '154878745215745755',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [SECURED, UNSECURED],
  stages: [
    stageStarted,
    stageSubmitted,
    stageUnderReview,
    stagePreQualified,
    stageApproval,
    stageApproved,
    stageWithdrawn,
    stageClosedForIncomplete,
    stageClearToCloseForCDP,
    stageUntouched,
    stageSoftDeclined
  ],
  roles: [USER_ONBOARD_CDP_OFFICER],
} as any


const adminStageConfigs = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [SECURED, UNSECURED],
  stages: [
    stageStarted,
    stageSubmitted,
    stageUnderReview,
    stagePreQualifiedAdmin,
    stageApprovalAdmin,
    stageCreditApprovalAdmin,
    stageDenialUnderReview,
    stageApproved,
    stageWithdrawn,
    stageClosedForIncomplete,
    stageClearToCloseForSecuredUnSecured,
    stageDocsEPrintLoanCloseEdit,
    stageDocsESignLoanCloseEdit,
    stageApprovedNotAcceptedEdit,
    stageUntouched,
    stageSoftDeclined
  ],
  roles: [
    SMARTMATCH_TYPE_ADMIN
  ],
} as any


const cmStageConfigs = {
  id: '154878745215745754',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [SECURED, UNSECURED],
  stages: [
    stageStarted,
    stageSubmitted,
    stageUnderReview,
    stagePreQualified,
    stageApproval,
    stageCreditApproval,
    stageDenialUnderReview,
    stageApproved,
    stageWithdrawn,
    stageClosedForIncomplete,
    stageClearToCloseForSecuredUnSecured,
    stageDocsEPrint,
    stageDocsInDocuSign,
    stageUntouched,
    stageSoftDeclined
  ],
  roles: [
    SMARTMATCH_TYPE_ADMIN,
    SMARTMATCH_TYPE_CREDIT_MANAGER
  ],
} as any


const closedLoanEditManager = {
  id: '154878745215745755',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [SECURED, UNSECURED, HOME_EQUITY],
  stages: [
    stageDocsEPrintLoanCloseEdit,
    stageDocsESignLoanCloseEdit,
    stageApprovedNotAcceptedEdit,
    {
      name: STATUS_PRE_QUALIFIED,
      display_name: STATUS_RECOMMENDED_APPROVE,

    },
    {
      name: STATUS_UNDER_REVIEW,
      display_name: STATUS_RECOMMENDED_DECLINE,

    },
  ],
  roles: [USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER],
} as any

// TODO: Update count limit in tree.ts
const auditorLoanEditManager = {
  id: '15497975215745755',
  namespace_id: APP_LS_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [SECURED, UNSECURED, HOME_EQUITY],
  stages: [
    {
      name: STATUS_APPLICATION_STARTED,
      display_name: STATUS_APPLICATION_STARTED,
    },
    {
      name: STATUS_SUBMITTED,
      display_name: STATUS_SUBMITTED,
    },
    {
      name: STATUS_UNDER_REVIEW,
      display_name: STATUS_RECOMMENDED_DECLINE,
    },
    {
      name: STATUS_PRE_QUALIFIED,
      display_name: STATUS_RECOMMENDED_APPROVE,
    },
    {
      name: STATUS_REQUEST_APPROVAL,
      display_name: STATUS_REQUEST_APPROVAL,
    },
    {
      name: STATUS_CREDIT_APPROVAL,
      display_name: STATUS_CREDIT_APPROVAL,
    },
    {
      name: STATUS_APPROVED,
      display_name: STATUS_APPROVED,
    },
    {
      name: STATUS_APPRAISAL_ORDER,
      display_name: STATUS_APPRAISAL_ORDER,
    },
    {
      name: STATUS_APPRAISAL_COMPLETE,
      display_name: STATUS_APPRAISAL_COMPLETE,
    },
    {
      name: STATUS_DOCUMENTS_SIGNED,
      display_name: STATUS_DOCUMENTS_SIGNED,
    },
    {
      name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
      display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    },
    {
      name: STATUS_DOCS_IN_EPRINT,
      display_name: STATUS_DOCS_IN_EPRINT,
    },
    {
      name: STATUS_DOCS_IN_DOCUSIGN,
      display_name: STATUS_DOCS_IN_DOCUSIGN,
    },
    {
      name: STATUS_DENIAL_UNDER_REVIEW,
      display_name: STATUS_DENIAL_UNDER_REVIEW,
    },
    {
      name: STATUS_FUNDING,
      display_name: STATUS_FUNDING,
    },
    {
      name: STATUS_BOOKING_COMPLETE,
      display_name: STATUS_BOOKING_COMPLETE,
    },
    {
      name: STATUS_WITHDRAW,
      display_name: STATUS_WITHDRAW,
    },
    {
      name: STATUS_DECLINED,
      display_name: STATUS_DECLINED,
    },
    {
      name: STATUS_CLOSED_FOR_INCOMPLETENESS,
      display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
    },
    {
      name: STATUS_APPROVED_NOT_ACCEPTED,
      display_name: STATUS_APPROVED_NOT_ACCEPTED,
    },
    {
      name: STATUS_UNTOUCHED,
      display_name: STATUS_UNTOUCHED,
    }
  ],
  roles: [AUDITOR],
} as any


export const personalLoanStages = [
  loStageConfigs,
  cdpStageConfigs,
  loStageHelocConfigs,
  cdpStageHelocConfigs,
  applicantStages,
  applicantStagesHeloc,
  adminStageConfigs,
  adminStagesHeloc,
  cmStagesHeloc,
  cmStageConfigs,
  drmStageConfigs,
  drmStageHelocConfigs,
  rateApproverStageConfigs,
  rateApproverStageHelocConfigs,
  closedLoanEditManager,
  auditorLoanEditManager
]